<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/haldipur0007#loi">List of Figures</a></p>
<p class="tocfm"><a class="xref" href="#/haldipur0008#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/haldipur0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/haldipur0010#ch01">1. The Invisible</a></p>
<p class="toc"><a class="xref" href="#/haldipur0011#ch02">2. Growing Up under Surveillance</a></p>
<p class="toc"><a class="xref" href="#/haldipur0012#ch03">3. Parenting the Dispossessed</a></p>
<p class="toc"><a class="xref" href="#/haldipur0013#ch04">4. Policing Immigrant Communities</a></p>
<p class="toc"><a class="xref" href="#/haldipur0014#ch05">5. Losing Your Right to the City</a></p>
<p class="toc"><a class="xref" href="#/haldipur0015#epil">Epilogue</a></p>
<p class="tocbmf"><a class="xref" href="#/haldipur0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/haldipur0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/haldipur0018#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/haldipur0019#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/haldipur0020#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// haldipur-0006.vue?d11d559e